import { render, staticRenderFns } from "./FormularioVueComponenteMenuComponent.vue?vue&type=template&id=553a6ad4"
import script from "./FormularioVueComponenteMenuComponent.vue?vue&type=script&lang=js"
export * from "./FormularioVueComponenteMenuComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports